import React from 'react';
import Helper from './Helper';
import _ from 'lodash';
class Paging extends React.Component {

    handleChangeLink=(page,e)=>{
        e.preventDefault();
        this.props.handleClickLink(page);
    }
    render(){
        let currentPath = window.location.pathname,
        arrayQueryString = Helper.queryStringToArray();
        _.remove(arrayQueryString,(item)=>Object.keys(item)[0]==='page');
        arrayQueryString = arrayQueryString.length ? arrayQueryString.map((item)=>{
            return `${Object.keys(item)[0]}=${item[Object.keys(item)[0]]}`
        }):[];    
        arrayQueryString.push("page");
        let {config} = this.props,
        {total,limit,currentPage,rangePage} = config,
        currentUrl = `${currentPath}?${arrayQueryString.join('&')}`,
        prev = currentPage <= 1 ? 0 : currentPage - 1,
        last = Math.ceil(total/limit),
        next = currentPage >= last ? 0 : currentPage + 1,
        rangeShow = [];
        
        let firstShow = Math.round(currentPage-rangePage/2) >=1 ? Math.round(currentPage-rangePage/2):1,
        lastShow = Math.round(currentPage + rangePage/2)-1 < last ? Math.round(currentPage + rangePage/2)-1: last; 
        for (let i = firstShow; i <= lastShow; i++) {
            let currentClass = i === currentPage ? 'paging__current':'';
            rangeShow.push(
                <li key={i} className={`paging__item ${currentClass}`}>
                    <a onClick={(e)=>this.handleChangeLink(i,e)} href={`${currentUrl}=${i}`} className="paging__link__ajax">{i}</a>
                </li>
            );
        }
        
        return (
            <div className="paging">
                <div className="offset-lg-2 col-12 col-lg-8">
                    <ul className="list-inline d-flex w-100 justify-content-center align-items-center">
                        {prev ? 
                        <li className="paging__item paging__prev">
                            <a onClick={(e)=>this.handleChangeLink(prev, e)} href={`${currentUrl}=${prev}`} className="paging__link__ajax">
                                <i className="fas fa-angle-left" />
                            </a>
                        </li>
                        :null}
                        
                        {firstShow > 1 ? 
                        <li className="paging__item paging__first">
                            <a onClick={e=>this.handleChangeLink(1,e)} href={`${currentUrl}=${1}`} className="paging__link__ajax">1</a>
                        </li>
                        :null}

                        {firstShow > 2 ?
                        <li className="paging__item paging__span">
                            <span>...</span>
                        </li>
                        :null}

                        {rangeShow}
                        
                        {lastShow < last-1 ?
                        <li className="paging__item paging__span">
                            <span>...</span>
                        </li>
                        :null}

                        {currentPage < last && lastShow < last ?     
                        <li className="paging__item paging__last">
                            <a onClick={e=>this.handleChangeLink(last,e)} href={`${currentUrl}=${last}`} className="paging__link__ajax">{last}</a>
                        </li>
                        :null}
                        {next ? 
                        <li className="paging__item paging__next">
                            <a onClick={e=>this.handleChangeLink(next, e)} href={`${currentUrl}=${next}`} className="paging__link__ajax">
                            <i className="fas fa-angle-right" />
                            </a>
                        </li>
                        :null}
                    </ul>
                </div>
            </div>
        )
    }
}
export default Paging;